<div class="lightTheme">
  <div *ngIf="isLoading" class="svg-loader"></div>
  <div class="d-flex flex-row page-header">
    Hub
    <button class="actionIcon pointer" routerLink="/workflowBuilder" class="btn actionBtn add p-0" matTooltip="Add Workflow"
    matTooltipPosition="right"></button>
  </div>

  <div class="d-flex search_filter_area ">
    <div id="searchBar" class="d-inline-block">
      <input type="text" class="form-control" (keyup)="applyFilter($event.target.value)" placeholder="Search" [(value)]="searchText">
      <span class="searchIcon"><mat-icon aria-hidden="false" aria-label="search">search</mat-icon></span>
    </div>
    <div class="col-8 col-sm-8 col-md-8 col-lg-8 regularText">
      <mat-chip-listbox #chipList>
        <mat-chip-option *ngFor="let element of selectedFilters" [removable]="true" (removed)="remove(element)">
          {{globals.replaceDisplayText(element.selectedFieldName) + " " + element.selectedCondition + " " + element.selectedValue}}
          <mat-icon matChipRemove *ngIf="true">cancel</mat-icon>
        </mat-chip-option>
      </mat-chip-listbox>
    </div>
    <div class="tbl_head_action float-right">
      <span class="filterIcon" placement="left-top" [ngbPopover]="addFilter" #popOver="ngbPopover" popoverTitle="Add Filter" autoClose="outside" popoverClass="popClassWidth"></span>
      <span class="exportIcon" (click)="exporter.exportTable('xlsx', {fileName:'Workflow', sheet: 'Workflow_list'})"></span>
    </div>
  </div>
  <div class="d-flex flex-column hubTable">
    <mat-table matTableExporter [dataSource]="workflowListDetails" matSort matSortActive="lastRun" matSortDirection="desc"
               matSortDisableClear #exporter="matTableExporter" hiddenColumns="[0,7]">
      <ng-container matColumnDef="status">
        <mat-header-cell *matHeaderCellDef class="addBtn-col">
        </mat-header-cell>
        <mat-cell *matCellDef="let element; let i = index" class="addBtn-col">
          <span class="status" [ngClass]="{'online': (element.status.toLowerCase() == 'active')}">
            <span class="statusSymbol" matTooltip="{{element.status}}"></span>
          </span>
          <select class="select_box" id="status" name="status" [(ngModel)]="element.status"
                  (change)="onStatusChange(element, i)">
            <option *ngFor="let item of statusOption" [ngValue]="item">{{item}}</option>
          </select>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="workflowName">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Workflow Name</mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.workflowName}} </mat-cell>
      </ng-container>
      <ng-container matColumnDef="workflowDescription">
        <mat-header-cell *matHeaderCellDef class="description-col">Description</mat-header-cell>
        <mat-cell *matCellDef="let element" class="description-col"> {{element.workflowDescription}} </mat-cell>
      </ng-container>
      <ng-container matColumnDef="workflowId">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Workflow Id</mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.workflowId}} </mat-cell>
      </ng-container>
      <ng-container matColumnDef="lastRun">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Last Run</mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.lastRun | date: 'yyyy-MM-dd T HH:mm:ss' }} </mat-cell>
      </ng-container>
      <ng-container matColumnDef="lastRunStatus">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Last Run Status</mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.lastRunStatus}} </mat-cell>
      </ng-container>
      <ng-container matColumnDef="lastUpdatedBy">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Last Modified By​</mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.lastUpdatedBy}} </mat-cell>
      </ng-container>
      <ng-container matColumnDef="Action">
        <mat-header-cell *matHeaderCellDef><span class="ml4">Action</span></mat-header-cell>
        <mat-cell class="tbl_action" *matCellDef="let element;">
          <button class="actionIcon pointer"
                  [routerLink]="['/workflowBuilder', {id:element.workflowId, isEdit: false, status: element.status}]" matTooltip="View"
                  mat-icon-button>
            <mat-icon class="action-icon-view"></mat-icon>
          </button>
          <div *ngIf="element.status=='Inactive'" (click)="editWorkflow(element)" [matTooltip]="element.status=='Active'?'Edit':''">
            <button class="actionIcon pointer" matTooltip="Edit" [routerLink]="['/workflowBuilder', {id:element.workflowId, isEdit: true, status: element.status}]"
                    [disabled]="element.status=='Active'" mat-icon-button>
              <mat-icon class="action-icon-edit"></mat-icon>
            </button>
          </div>
          <div *ngIf="element.status=='Active'" (click)="editWorkflow(element)" [matTooltip]="element.status=='Active'?'Edit':''">
            <button class="actionIcon pointer" matTooltip="Edit" mat-icon-button>
              <mat-icon class="action-icon-edit"></mat-icon>
            </button>
          </div>
          <button class="actionIcon pointer" (click)="deleteWorkflow(element.workflowId)" matTooltip="Delete" mat-icon-button>
            <mat-icon class="action-icon-delete"></mat-icon>
          </button>
          <button class="actionIcon pointer" matTooltip="Report" (click)="loadReport(element.workflowId, element.workflowName)" mat-icon-button>
            <mat-icon class="action-icon-report"></mat-icon>
          </button>
        </mat-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

    </mat-table>
    <div *ngIf="(workflowListDetails.data.length === 0) && (!isLoading)" class="emptyRepoMsg">
      <span> There are no records to display.</span>
    </div>
    <mat-paginator #paginator [pageSizeOptions]="[10,20,30]" [pageSize]="10" [hidden]="!workflowListDetails.data.length">
    </mat-paginator>
  </div>
  <div class="clearfix"></div>
  <ng-template #addFilter><app-add-filter [filterList]="filterList" [selectedFilters]="selectedFilters" (filterResponse)="filterResponse($event)"></app-add-filter></ng-template>
</div>
